"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toastFooterClassNames: function() {
        return toastFooterClassNames;
    },
    useToastFooterStyles_unstable: function() {
        return useToastFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const toastFooterClassNames = {
    root: 'fui-ToastFooter'
};
/**
 * Styles for the root slot
 */ const useRootBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r1u6izx1", null, [
    ".r1u6izx1{padding-top:16px;grid-column-start:2;grid-column-end:3;display:flex;align-items:center;column-gap:14px;row-gap:14px;}"
]);
const useToastFooterStyles_unstable = (state)=>{
    const rootBaseClassName = useRootBaseClassName();
    state.root.className = (0, _react.mergeClasses)(toastFooterClassNames.root, rootBaseClassName, state.root.className);
    return state;
}; //# sourceMappingURL=useToastFooterStyles.styles.js.map
